import { App } from "@ng-mw/shared-react-components"

export default {
    ...App.LocalStorage,
    DietSugarProperty: "TRUMF_DIET_SUGAR_PROPERTY",
    MockAccessToken: "MENY_MOCK_ACCESS_TOKEN",
    UserAskedToRateApp: "MENY_USER_ASKED_TO_RATE_APP",
    UserInteractedWithFeedback: "CLOSED_FEEDBACK_", // + feedbackId
    UserSeenDietAddedSugarInfo: "TRUMF_HAS_SEEN_DIET_ADDED_SUGAR_INFO",
    UserSeenInsightOnboardingPopup: "TRUMF_HAS_SEEN_INSIGHT_ONBOARDING_POPUP",
    UserSeenAppNewsPopup: "MENY_HAS_SEEN_NEWS_POPUP",
    UserSeenAppNewsTrumfBonusPopup: "MENY_HAS_SEEN_NEWS_TRUMF_BONUS_POPUP",
    UserSeenAppNewsBestBuyPopup: "MENY_HAS_SEEN_NEWS_BEST_BUY_POPUP",
    UserSeenLoyaltyClubWelcomePopup: "MENY_HAS_SEEN_WELCOME_POPUP",
    UserSeenLoyaltyClubWelcomeBox: "MENY_HAS_SEEN_WELCOME_BOX",
    UserSeenNewOnboarding: "USER_HAS_SEEN_NEW_ONBOARDING",
    UserSeenPushPopup: "USER_HAS_SEEN_PUSH_POPUP",
    UserSeenPersonalCampaign: "USER_HAS_SEEN_PERSONAL_CAMPAIGN",
    MobilePushStatus: "MOBILE_PUSH_STATUS",
    UserSeenMyRecipesInfoPopup: "MENY_HAS_SEEN_MY_RECIPES_INFO_POPUP",
    DinnerSuggestionsOnboarding: "MENY_DINNER_SUGGESTIONS_ONBOARDING",
    DinnerSuggestionsLastFetchDate: "MENY_DINNER_SUGGESTIONS_LAST_FETCH_DATE_", // + memberId
    UserEnabledNewCorporateFlow: "WEBSHOP_USER_ENABLED_NEW_CORPORATE_FLOW",
    GodeKjopNudge: "godeKjopNudge",
}
